import styled from 'styled-components'

export const ContentContainer = styled.div`
  width: 100%;
  padding: 16px;
`

export const StyledText = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: #0c1014;
  text-align: justify;
  font-family: Barlow;
  font-weight: 400;
  font-style: normal;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    font-size: 24px;
    line-height: 32px;
    margin: 24px auto;
    max-width: 1200px;
  }
`

export const Container = styled.div`
  margin: 40px 0;
`
